import React from "react";
import { connect } from "react-redux";

import { getBasketItemByID } from "state/school_money/selectors";

import Date from "components/Date";

import "./BasketItemIssue.css";

class BasketItemIssue extends React.Component {

  getClubBookingDescription(payload) {
    const { description, startDate } = payload.get("clubBooking").toObject();
    return [ description, <span>W/C <Date date={startDate} /></span> ];
  }

  getDinnerBookingDescription(payload) {
    const { description, startDate } = payload.get("dinnerBooking").toObject();
    return [ description, <span>W/C <Date date={startDate} /></span> ];
  }

  getPaymentInstallmentDescription(payload) {
    const { payment, installmentNumber } = payload.toObject();
    const { description, installments,  } = payment.toObject();
    const { dueDate } = installments.get(installmentNumber).toObject();
    const firstLine = `${description} (instalment ${installmentNumber})`;
    return [ firstLine, <span>Due <Date date={dueDate} /></span> ];
  }

  getShopItemDescription(payload) {
    const { quantity, shopItem } = payload.toObject();
    return [ shopItem.get("name"), `Quantity x${quantity}` ];
  }

  getItemDescription() {
    const { type, payload } = this.props.basketItem.toObject();
    switch (type) {
      case "clubBooking": return this.getClubBookingDescription(payload);
      case "dinnerBooking": return this.getDinnerBookingDescription(payload);
      case "payment": return this.getPaymentInstallmentDescription(payload);
      case "shopItem": return this.getShopItemDescription(payload);
      default: return "";
    }
  }

  render() {
    const [ firstLine, secondLine ] = this.getItemDescription();
    return (
      <div className="basket-item-issue">
        <div className="basket-item-issue__first-line">{ firstLine }</div>
        <div className="basket-item-issue__second-line">{ secondLine }</div>
      </div>
    )
  }

}

export default connect(
  (state, { itemType, basketItemID }) => ({
    basketItem: getBasketItemByID(state, itemType, basketItemID)
  })
)(BasketItemIssue);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/BasketItemIssue.js